<div class="container">
  <div class="row">
    <h3 *ngIf="crudMode" class="page-title" style="margin-left: 15px;">Solicitações</h3>
    <!-- <button -->
    <!--     class="btn btn-link ml-auto" -->
    <!--     style="padding-top: 0px; padding-bottom: 0px; margin-top: -20px;" -->
    <!--     data-toggle="tooltip" title="Solicitação avulsa" -->
    <!--     [hidden]="requesting || !crudMode" -->
    <!--     (click)="startRequesting()"> -->
    <!--   <fa-icon [icon]="editIcon" class="fa-2x mr-3"></fa-icon> -->
    <!-- </button> -->
  </div>

  <input
    type="text"
    autofocus
    class="form-control"
    style="margin-bottom: 15px;"
    #searchBox
    id="searchBox"
    placeholder="Digite o nome do procedimento para pesquisar"
    (keyup)="search(searchBox.value)" />

  <mc-exam-template-list [templates]="examTemplates" [crudMode]="crudMode" (selected)="selectedTemplate($event)"></mc-exam-template-list>

  <blockquote class="blockquote text-center mt-5" *ngIf="examTemplates?.length == 0">
    <p *ngIf="crudMode">Nenhum procedimento foi encontrado, gostaria de
      <span class="h4"><strong><em>
            <a class="btn btn-outline-primary btn-lg ml-1" routerLink="nova">criar um novo?</a>
      </em></strong></span>
    </p>
    <p *ngIf="!crudMode">Nenhum procedimento foi encontrado.</p>
  </blockquote>

  <mc-exam-form *ngIf="requesting"></mc-exam-form>
</div>
